import React from "react";

export default function CostIcon() {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.4338 11.3333L39.3333 17.5618V35.0393L39.7073 34.8254L47.5667 30.3333H63.2668L74.1663 36.5618V64.7708L63.2659 71.0002H47.5676L38.1243 65.6047L38.0002 65.5344L37.8762 65.6047L28.4329 71.0002H12.7336L1.83325 64.7708V17.5618L12.7327 11.3333H28.4338Z"
        fill="#35D7E4"
        stroke="#E6FAFC"
        strokeWidth="0.5"
      />
      <path
        d="M74.1663 64.7712L63.2678 70.9998H55.6663V42.9998H63.3997L63.4573 42.9675L74.1663 36.8464V64.7712ZM39.3333 34.4597L36.2922 36.2L36.1663 36.2722V65.0613L36.2922 65.1335L37.4924 65.822L28.4338 70.9998H20.8333V23.9998H28.5667L28.6243 23.9675L39.3333 17.8464V34.4597Z"
        fill="#086E86"
        stroke="#E6FAFC"
        strokeWidth="0.5"
      />
      <path
        d="M39.5833 26.9167V17.4167L28.4999 23.7501H12.6666L1.58325 17.4167V64.9167"
        stroke="#E6FAFC"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5833 26.9166L28.4999 33.2499H12.6666L1.58325 26.9166M30.0041 41.8918L28.4999 42.7499H12.6666L1.58325 36.4166M30.0041 51.3918L28.4999 52.2499H12.6666L1.58325 45.9166M30.0041 60.8918L28.4999 61.7499H12.6666L1.58325 55.4166M30.0041 70.3918L28.4999 71.2499H12.6666L1.58325 64.9166M1.58325 17.4166L12.6666 11.0833H28.4999L39.5833 17.4166M74.4166 64.9166V36.4166L63.3332 42.7499H47.4999L36.4166 36.4166V64.9166"
        stroke="#E6FAFC"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.4165 45.9167L63.3332 52.25H47.4998L36.4165 45.9167M74.4165 55.4167L63.3332 61.75H47.4998L36.4165 55.4167M74.4165 64.9167L63.3332 71.25H47.4998L36.4165 64.9167M36.4165 36.4167L47.4998 30.0833H63.3332L74.4165 36.4167M58.5832 4.75V7.91667M58.5832 20.5833V23.75M68.0832 14.25H64.9165M52.2498 14.25H49.0832"
        stroke="#E6FAFC"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
